import React from 'react';
import PropTypes from 'prop-types';

import ErrorBoundary from '../ErrorBoundary';

const Body = ({ catchComponentError, children, onCatch }) => (
  <div className="sidebar__body">
    {catchComponentError
      ? (
        <ErrorBoundary onCatch={onCatch}>
          {children}
        </ErrorBoundary>
      )
      : children
    }
  </div>
);

Body.propTypes = {
  /** Indica se il componente isola gli errori
     * derivanti da componente renderizzati internamente */
  catchComponentError: PropTypes.bool,
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   * Callback invocata in caso di eccezione:
   * ```
   *  onCatch(error, errorInfo)
   * ```
   * dove:
   * * *error*: errore scatenato
   * * *errorInfo*: contiene il componentStack con lo stack dell'errore
   */
  onCatch: PropTypes.func,
};

Body.defaultProps = {
  catchComponentError: true,
  children: null,
  onCatch: null,
};

export default Body;
